import { api } from '@api'

interface ticketFilePayload {
  ticketId: number | undefined
  ticketFile: File
}

const ticketFiles = async (payload: ticketFilePayload) => {
  const newFile = new FormData()
  if (payload.ticketFile instanceof File) {
    newFile.append('ticketFile', payload.ticketFile)
  } else {
    throw new Error('ticketFile is not a File object')
  }
  const response = await api.post(`/tickets/${payload.ticketId}/add-file`, newFile)
  return response.data
}

const getTicketFileUrl = async (id?: number) => {
  const response = await api.get(`/tickets/download-file/${id}`)
  return response.data
}

const downloadTicketFile = async (fileUrl: string) => {
  const response = await api.get(fileUrl)
  const blob = response.data.blob()
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileUrl
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export const ticketFilesApi = {
  ticketFiles,
  getTicketFileUrl,
  downloadTicketFile,
}
